module.exports = __webpack_public_path__ + "static/media/phone.ed731246.svg";


//////////////////
// WEBPACK FOOTER
// ./src/styles/images/phone.svg
// module id = 2614
// module chunks = 0